import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseUrl = "http://hdeng2024.cafe24.com/api/controller/user";

export const contentsApiSlice = createApi({
  reducerPath: "contentsApiSlice",
  baseQuery: fetchBaseQuery({ baseUrl: baseUrl }),
  endpoints: (builder) => ({
    // 홍보센터 가져오기
    getUserContentList : builder.mutation({
      query : (param : {contentsType : any, lang : string, page : any, size : number, keyword : string, sortOrder : string, sortColumn : string}) => {
        return{
          url : `/contents/getUserContentList.php?promContentType=${param.contentsType}&LangType=${param.lang}&page=${param.page}&size=${param.size}&keyword=${param.keyword}&sortColumn=${param.sortColumn}&sortOrder=${param.sortOrder}`
        }
      }
    }),
    // 홍보센터 상세보기
    getUserContentDetail : builder.mutation({
      query : (param : {contentsType:any, idx : any}) => {
        return{
          url : `/contents/getUserContentDetail.php?promContentType=${param.contentsType}&prom_idx=${param.idx}`
        }
      }
    }),
    // 문의하기
    setUserInquiry : builder.mutation({
      query : (body : any) => {
        return{
          url : '/inquiry/setUserInquirys.php', method : 'post', body
        }
      }
    }),
    // FAQ
    getUserFaq : builder.mutation({
      query : (param : {lang : string, page : any, size : number, keyword : string, sortOrder : string, sortColumn : string}) => {
        return{
          url : `/faq/getFaqList.php?LangType=${param.lang}&page=${param.page}&size=${param.size}&keyword=${param.keyword}&sortColumn=${param.sortColumn}&sortOrder=${param.sortOrder}`
        }
      }
    })
  }),
});

export const {
  useSetUserInquiryMutation, useGetUserContentListMutation, useGetUserContentDetailMutation, useGetUserFaqMutation
} = contentsApiSlice